<template>
  <div class="md:tw-mx-16 tw-pb-48 md:tw-pb-24 md:tw-pt-4 lg:tw-pt-4">
    <div class="tw-text-left tw-mb-8 tw-mx-4 md:tw-mx-0">
      <RouterLink to="/menu" class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">Menu</RouterLink> >
      <template v-if="selectedCategory">
        <span
          class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2">
            {{selectedCategory.name}}
        </span>
      </template>
    </div>

    <div class="tw-flex">
      <div class="tw-flex-shrink-0 tw-w-156 tw-hidden xl:tw-block">
        <template v-if="viewLoading">
          <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white">
            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
          
            <div class="tw-px-8">
              <SkeletonLoader class="tw-w-1/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-2/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-px-16 tw-py-12">
            <CategoryLink
              class="tw-mb-4 tw-w-full tw-block"
              v-for="category in getMenu"
              :key="category.id"
              :category="category"
            />

            <div class="tw-mb-4 tw-w-full tw-block">
              <router-link class="tw-cursor-pointer tw-group tw-w-full tw-block" :to="{ name: 'all-categories'}">
                <div :class="['tw-uppercase']">
                  All Categories
                </div>
              </router-link>
            </div>
          </div>
        </template>

      </div>

      <div class="tw-w-full tw-flex-1 lg:tw-mx-12">
        <div class="tw-mx-8 md:tw-mx-0" 
          v-if="userStore.userLocation && userStore.userLocation.id">
          <LocationAlerts :location="(userStore.userLocation! as any) as Location" />
        </div>

        <template v-if="viewLoading">
          <div class="tw-mb-8">
            <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-px-16 tw-py-16">
              <div class="tw-relative">
                <SkeletonLoader class="tw-w-1/3 tw-h-16 tw-mb-8" />
                <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
              </div>
            </div>
          </div>

          <div class="tw-flex tw-flex-wrap tw--mx-1 lg:tw--mx-4 xl:tw--mx-1 2xl:tw--mx-4">
            <div 
              class="tw-flex md:tw-my-1 md:tw-px-1 tw-w-full md:tw-w-1/2 xl:tw-w-full md:tw-mb-8 2xl:tw-mb-8 2xl:tw-px-4 2xl:tw-w-1/3 tw-border-b tw-border-gray-500 md:tw-border-b-0" 
              v-for="idx in 6" 
              :key="'loader-'+idx">
              <div class="tw-overflow-hidden tw-rounded-3xl tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-block">
                <div class="tw-overflow-hidden tw-block tw-h-auto tw-w-full">
                  <SkeletonLoader class="tw-w-full tw-h-96" />
                </div>
                <div class="tw-mx-12 tw-mt-8 tw-pb-8">
                  <SkeletonLoader class="tw-w-full tw-h-12" />
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <template v-if="selectedCategory">
            <div class="tw-mb-8">
              <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-px-16 tw-py-16">
                <div class="tw-relative">
                  <h2 class="tw-text-6xl tw-font-black tw-mr-auto tw-transition-all tw-duration-300">
                    {{selectedCategory!.name}}
                  </h2>
                  <div class="tw-italic tw-transition-all tw-duration-300 tw-pt-4">
                    {{selectedCategory!.description}}
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="tw-flex tw-flex-wrap tw--mx-1 lg:tw--mx-4 xl:tw--mx-1 2xl:tw--mx-4">
            <CategoryProduct
              class="tw-flex md:tw-my-1 md:tw-px-1 tw-w-full md:tw-w-1/2 xl:tw-w-full md:tw-mb-8 2xl:tw-mb-8 2xl:tw-px-4 2xl:tw-w-1/3 tw-border-b tw-border-gray-500 md:tw-border-b-0"
              v-for="product in getProducts"
              :key="product.id"
              :addingProduct="addingProducts.indexOf(product.id.toString()) > -1"
              :quantity="product.quantity!"
              :product="product"
              :assistanceLevel="(cateringOrderStore.cateringOrder != null ? cateringOrderStore.cateringOrder!.assistance_level! : 0)"
              @handleProductAdd="addProduct"
              @handleDetailsModal="popDetailsModal"
             />
          </div>
        </template>
      </div>

      <div class="tw-flex-shrink-0 tw-w-156 tw-hidden lg:tw-block">
        <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-mb-16">
          <OrderDetails />
          <Bag />
          <div class="tw-border-black tw-border-t tw-border-black tw-pt-8 tw-px-8" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
            <BagTotals />
          </div>
          <div class="tw-text-center tw-mt-16" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
            <router-link
              :to="{ name: 'review-bag'}"
              class="tw-block tw-w-full tw-bg-orange-medium tw-text-white hover:tw-bg-orange-dark hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200" 
              >
              Checkout
            </router-link>
          </div>
        </div>


      <TwCateringHelp />
  
      </div>
    </div>

    <TwModal
      v-show="productDetailsOpen"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="closeDetailsModal"
      >

      <template v-slot:body>
        <template v-if="productDetailsItem">
          <div class="tw-relative tw-pr-24 tw-w-full">
            <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">{{productDetailsItem!.name}}</h2>
            <h2 class="tw-mx-8 tw-font-bold tw-text-4xl tw-block lg:tw-hidden tw-mb-4">${{ productDetailsItem!.cost!.toLocaleString("en-US", {minimumFractionDigits: 2}) }}</h2>

             <button
                type="button"
                class="tw-text-5xl tw-absolute tw-right-2 tw-top-0 hover:tw-text-orange-medium tw-transition-all tw-duration-300"
                @click="closeDetailsModal"
              >
                &times;
              </button>
          </div>

          <p class="tw-mx-8 tw-mb-8 tw-text-3xl !tw-leading-relaxed">
            {{productDetailsItem!.description}}
          </p>

          <div class="tw-flex-1 tw-mx-4 tw-flex tw-justify-start tw-mb-3" v-if="modalButtonPath == 'addToBag'">
            <div class="tw-flex tw-items-center tw-relative tw-max-w-xs">
              <input 
              v-model="productDetailsQuantity"
              min="1"
              increment="1"
              class="tw-w-full tw-text-3xl tw-max-w-96 tw-text-center tw-px-16 tw-py-3 tw-border focus:tw-outline-none tw-border-gray-400 focus:tw-border-orange-medium focus:tw-ring-0 tw-rounded-full"
              type="number">
              <button
                @click="decrementQuantity"
                class="tw-px-8 tw-text-4xl hover:tw-text-orange-medium tw-transition-all tw-font-bold tw-text-black tw-absolute tw-left-0">
                &mdash;
              </button>

              <button
                @click="incrementQuantity"
                class="tw-px-8 tw-text-4xl hover:tw-text-orange-medium tw-transition-all tw-font-bold tw-text-black tw-absolute tw-right-0 ">
                +
              </button>
            </div>
          </div>
        </template>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8" v-if="productDetailsItem">
          <TwButton 
            cssClass="tw-border-2 tw-border-gray-400 tw-text-gray-400 hover:tw-bg-orange-medium hover:tw-border-orange-medium hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full"
            @emit-click="closeDetailsModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Close'"/>

          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full tw-inline-block lg:tw-hidden"
            @emit-click="handleProductDetailsButtonClick" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="modalAddToBagText"/>

          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full tw-hidden lg:tw-inline-block"
            @emit-click="handleProductDetailsButtonClick" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="modalAddToBagText"/>
        </div>
      </template>
    </TwModal> 

  </div>
</template>

<script setup lang="ts">
  import {
    ref, defineComponent, reactive, computed, onMounted,
  } from 'vue';
  import { useRoute } from 'vue-router';

  // Data
  import { useBasketStore } from '../../stores/basket';
  import { useMenuStore } from '../../stores/menu';
  import { useUserStore } from '../../stores/user';
  import { useCateringOrderStore } from '../../stores/catering_order';
  import { plainToClass } from 'class-transformer';

  import SkeletonLoader from '../../components/SkeletonLoader.vue';
  import Product from '../../classes/Product';
  import type MenuCategory from '../../classes/MenuCategory';
  import { useFlashMessageStore } from '../../stores/flashMessages';

  import type FlashMessage from '../../types/FlashMessage';
  import type Location from '../../classes/Location';

  const flashMessageStore = useFlashMessageStore();

  // Components
  import CategoryProduct from './_CategoryProduct.vue'
  import OrderDetails from '../bag/_OrderDetails.vue'
  import Bag from '../bag/_Bag.vue'
  import BagTotals from '../bag/_BagTotals.vue'
  import CategoryLink from './_CategoryLink.vue'
  import LocationAlerts from '../../components/LocationAlerts.vue';
  import TwCateringHelp from '../../components/TwCateringHelp.vue';
  import TwModal from '../../components/TwModal.vue';
  import TwButton from '../../components/TwButton.vue';

  const basketStore = useBasketStore();
  const menuStore = useMenuStore();
  const cateringOrderStore = useCateringOrderStore();
  const userStore = useUserStore();

  const route = useRoute();
  import { useRouter } from 'vue-router';
  const router = useRouter();

  const addingProducts = ref([] as string[]);
  const selectedCategory = ref(undefined as (MenuCategory | undefined));

  const productDetailsItem = ref(undefined as (Product | undefined));
  const productDetailsOpen = ref(false);
  const productDetailsQuantity = ref(1);

  const getMenu = computed(() => {
    return menuStore.getFilteredMenu;
  });

  const getProducts = computed(() => {
    let products = [] as Product[];
    let category = null as (MenuCategory | null);

    if (getMenu.value && getMenu.value.length) {
      category = getMenu.value.find((category) => {
        return category.id == route.params.id
      }) as MenuCategory
    }

    if (category && category.products) {
      selectedCategory.value = category;

      products = [] as Product[];

      category.products.forEach((prod: Product) => {
        prod.quantity = 1;
        products.push(plainToClass(Product, (prod as object), { excludeExtraneousValues: true }));
      });
    }

    return products
  })

  onMounted(() => {
    if (userStore.userLocation != null) {
      menuStore.fetchMenu(parseFloat(userStore.userLocation.extref));
    } else {
      alert('A location has not been selected.')
       router.push('wizard'); // User doesn't have a location set so force them to pick one;
    }
  })

  const handleProductDetailsButtonClick = (() => {
    if (modalButtonPath.value == "customize") {
      router.push({ name: 'product', params: { id: productDetailsItem.value!.id}})
      closeDetailsModal()
    } else if (modalButtonPath.value == "addToBag" && addingProducts.value.indexOf(productDetailsItem.value!.id.toString()) == -1) {
      productDetailsItem.value!.quantity = productDetailsQuantity.value;
      addProduct(productDetailsItem.value!);
      closeDetailsModal();
    }
  })

  const addProduct = (product: Product) => {
    addingProducts.value.push(product.id.toString());

    let quantity = product.quantity ? product.quantity : 1;
    basketStore.addProduct(product.id.toString(), quantity, "", [], [], undefined).then(() => {
      const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "success",
        text: "Product has been added to bag",
        headline: "",
        delay: 5000, // ms
        icon: "",
        cssClass: "",
      } as FlashMessage;
      flashMessageStore.addMessage(message);

      addingProducts.value.splice(addingProducts.value.indexOf(product.id), 1);
      product.quantity = 1;
    }).catch((error: Error) => {
      const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "danger",
        text: (error.message != null ? error.message : 'Product could not be added. Try again later.'),
        headline: "Error",
        delay: 0, // ms
        icon: "",
        cssClass: "",
      } as FlashMessage;
      flashMessageStore.addMessage(message);

      addingProducts.value.splice(addingProducts.value.indexOf(product.id), 1);
    })
  }

  const modalProductPrice = computed(() => {
    if (productDetailsItem) {
      let total = productDetailsItem.value!.priceWithDefaults();

      if (modalButtonPath.value == 'addToBag') {
        total = total * productDetailsQuantity.value;
      }

      return total.toLocaleString("en-US", {minimumFractionDigits: 2})
    } else {
      return 0
    }
  })

  const decrementQuantity = () => {
    productDetailsQuantity.value = Math.max(productDetailsQuantity.value -= 1, 1);
  };

  const incrementQuantity = () => {
    productDetailsQuantity.value = Math.min(productDetailsQuantity.value += 1, 99);
  };

  const popDetailsModal = (product: Product) => {
    productDetailsItem.value = product;
    productDetailsQuantity.value = product.quantity;
    productDetailsOpen.value = true;
  }

  const closeDetailsModal = (() => {
    productDetailsOpen.value = false;
    window.setTimeout(function() {
      // Give the modal time to close before erasing the values
      productDetailsItem.value = undefined;
    }, 500);
  })

  const modalButtonPath = computed(() => {
    let path = "customize"
    
    if (productDetailsItem.value && productDetailsItem.value.metadata != null) {
      if (productDetailsItem.value.getMetaDataByKey("modifiable") != null && productDetailsItem.value.getMetaDataByKey("modifiable") == false) {
        path = "addToBag"
      } else if (productDetailsItem.value.getMetaDataByKey("buttonPath") && productDetailsItem.value.getMetaDataByKey("buttonPath") != "customize") {
        // ?
      }
    }

    return path;
  })

  const modalAddToBagText = computed(() => {
    let str = '';
    if (productDetailsItem.value) {
      if (modalButtonPath.value == 'customize') {
        str = 'Customize Item';
      } else {
        str = 'Add to Bag - $';
        str += modalProductPrice.value
      }
    } else {
      
    }

    return str;
  })

  const viewLoading = computed(() => {
    let basketLoaded = false;
    let menuLoaded = false;
    let imagesLoaded = true;

    if (localStorage.getItem('mypiadaBasketId')) {
      if (basketStore.basket && basketStore.basket.id) {
        basketLoaded = true;
      }
    } else {
      basketLoaded = true;
    }
    if (getProducts.value && getProducts.value.length > 0) {
      menuLoaded = true;
    }

    return (!basketLoaded || !menuLoaded || !imagesLoaded);
  })

</script>
